import { NOT_FOUND } from 'redux-first-router';
import * as types from '../actions/actionTypes';
import { getNavigationSewpatTitle } from './sewpats';

export default (state = 'Schnoffle.de', action = {}) => {
    const lang = (
        action.payload || {}
    ).language || 'de';

    switch (action.type) {
        case types.NAVIGATED_TO_TOPCATEGORIES:
        case types.NAVIGATED_TO_SUBCATEGORIES:
        case types.NAVIGATED_TO_CATEGORIE_PATTERNS_GALLERY:
        case types.NAVIGATED_TO_SEWPAT_PATTERN_GALLERY:
        case types.NAVIGATED_TO_NEWEST_PATTERNGALLERY:
        case types.NAVIGATED_TO_DEFAULT_NEWEST_PATTERNGALLERY:
            return lang === 'de' ? 'Stoff wählen' : 'Choose Pattern';

        case types.NAVIGATED_TO_HASHTAG:
            return lang === 'de' ? 'Nähpaket gewinnen' : 'Win a schnoff';

        case types.NAVIGATED_TO_NEWSLETTER_FORM:
            return 'Schnoffle News';

        case types.NAVIGATED_TO_SINGLE_PATTERN_VIEW:
            return lang === 'de' ? 'Nähpaket bestellen' : 'Customize Pattern';

        case types.NAVIGATED_TO_SEWPAT_VIEW:
            return lang === 'de' ? 'Schnitt' : 'Sewing Pattern';

        case types.NAVIGATED_TO_SEWPAT_GALLERY:
            return lang === 'de' ? 'Schnitt wählen' : 'Choose Sewing Patterns';

        case NOT_FOUND:
            return lang === 'de' ? 'Ooops, Sackgasse!' : 'Ooops, dead end.';

        case types.NAVIGATED_TO_SEARCHGALLERY:
            return lang === 'de' ? 'Stoffsuche' : 'Patternsearch';

        case types.NAVIGATED_TO_LOVED_PATTERNS:
            return lang === 'de' ? 'Merkliste' : 'Favorites';

        case types.NAVIGATED_TO_PATTERNS_FROM_DESIGNER:
            return lang === 'de' ? 'Designergalerie' : 'Designergallery';

        case types.NAVIGATED_TO_FAQ_FABRICS:
            return lang === 'de' ? 'FAQ Stoffe' : 'FAQ Fabrics';

        case types.NAVIGATED_TO_FAQ_SEWPATS:
            return lang === 'de' ? 'FAQ Schnittmuser' : 'FAQ Sewing Pattern';

        case types.NAVIGATED_TO_COLORSWATCHES_CART_FORM:
            return lang === 'de' ? 'Griff- & Farbmuster' : 'Colors & Swatches';

        case types.NAVIGATED_TO_IMPRINT:
            return lang === 'de' ? 'Impressum' : 'Imprint';

        case types.NAVIGATED_TO_PRIVACY:
            return lang === 'de' ? 'Datenschutz' : 'Privacy';
        case types.NAVIGATED_TO_TOS:
            return lang === 'de' ? 'AGB' : 'TOS';
        case types.NAVIGATED_TO_FAQ_RECOLORING:
            return lang === 'de' ? 'FAQ Schnoff umfärben' : 'FAQ Customization';
        case types.NAVIGATED_TO_CONTACT:
            return lang === 'de' ? 'Kontakt' : 'Contact';
        case types.NAVIGATED_TO_FAQ_SHIPPING:
            return lang === 'de' ? 'FAQ Versand' : 'FAQ Shipping';

        default:
            return state || 'Schnoffle.de';
    }
};

export function getPageTitle(state) {
    if (state.page === 'SingleSewpatView') {
        const SewpatTitle = getNavigationSewpatTitle(state);
        return SewpatTitle;
    }
    return (
        state.title
    );
}



// WEBPACK FOOTER //
// ./src/reducers/title.js